/* CO VOZÍM JÁ — spojí živá data z kolekce s mapou míst a vět.
   Produkty jdou z Liquidu (ceny, sklad, dostupnost sedí samy),
   mapa `ktm-co-vozim.json` říká, kde je na fotce bod a co u dílu stojí za řeč. */
(function () {
  var sekce = document.querySelector(".cvj");
  if (!sekce) return;

  var uzel = sekce.querySelector("[data-cvj-produkty]");
  var produkty;
  try {
    produkty = JSON.parse(uzel.textContent);
  } catch (e) {
    return;                       // rozbitá data — necháme aspoň statický obsah
  }
  var podleSku = {};
  produkty.forEach(function (p) { if (p.sku) podleSku[p.sku] = p; });

  function stav(p) {
    if ((p.sklad || 0) > 0) return ["je", p.sklad + " ks ve Vlašimi"];
    var d = p.dostupnost || "";
    if (d.indexOf("Dočasně") === 0) return ["ne", "Dočasně nedostupné"];
    if (d.indexOf("Na objednání") === 0) return ["obj", "Na objednání"];
    if (d) return ["dod", d];
    return [p.koupitelne ? "dod" : "ne", p.koupitelne ? "Skladem u dodavatele" : "Nedostupné"];
  }

  function polozka(p, veta, tridaObalu) {
    var s = stav(p);
    return '<div class="' + tridaObalu + '">' +
      '<span class="cvj-pol-foto">' +
        (p.foto ? '<img src="' + p.foto + '" alt="" loading="lazy">' : "") + '</span>' +
      '<div><div class="cvj-znacka">' + p.vendor + '</div>' +
      '<h4><a href="' + p.url + '">' + p.nazev + '</a></h4>' +
      (veta ? '<div class="cvj-rada">' + veta + '</div>' : "") +
      '<span class="cvj-stav ' + s[0] + '">' + s[1] + '</span>' +
      '<div class="cvj-radek"><span class="cvj-cena">' +
        (p.rozsah ? "od " : "") + p.cena + '</span>' +
      '<button class="cvj-kosik" type="button" data-varianta="' + p.varianta + '"' +
        (p.koupitelne ? "" : " disabled") + '>' +
        (p.koupitelne ? "Do košíku" : "Nedostupné") + '</button></div></div></div>';
  }

  function dokosiku(ev) {
    var b = ev.target.closest(".cvj-kosik");
    if (!b || b.disabled) return;
    var puvodni = b.textContent;
    b.textContent = "Přidávám…"; b.disabled = true;
    fetch("/cart/add.js", {
      method: "POST", headers: {"Content-Type": "application/json"},
      body: JSON.stringify({items: [{id: Number(b.dataset.varianta), quantity: 1}]})
    }).then(function (r) {
      b.textContent = r.ok ? "Přidáno ✓" : "Nepovedlo se";
      setTimeout(function () { b.textContent = puvodni; b.disabled = false; }, 2200);
      if (r.ok) document.dispatchEvent(new CustomEvent("cart:refresh", {bubbles: true}));
    }).catch(function () {
      b.textContent = "Nepovedlo se";
      setTimeout(function () { b.textContent = puvodni; b.disabled = false; }, 2200);
    });
  }
  sekce.addEventListener("click", dokosiku);

  fetch(sekce.dataset.mapa).then(function (r) { return r.json(); }).then(function (mapa) {
    var mista = mapa.mista || [];
    var vety = mapa.vety || {};
    var body = sekce.querySelector("[data-body]");
    var panel = sekce.querySelector("[data-panel]");
    var mrizka = sekce.querySelector("[data-mrizka]");

    // ——— místa na motorce ———
    var platna = mista.filter(function (m) {
      m.kusy = (m.sku || []).map(function (s) { return podleSku[s]; }).filter(Boolean);
      return m.kusy.length;
    });

    function ukaz(i) {
      var m = platna[i], n = m.kusy.length;
      panel.innerHTML = '<div class="cvj-panel-hl"><h3>' + m.jmeno + '</h3><span>' +
        n + (n === 1 ? " věc" : (n < 5 ? " věci" : " věcí")) + '</span></div>' +
        m.kusy.map(function (p) {
          return polozka(p, vety[p.sku], "cvj-pol");
        }).join("");
      body.querySelectorAll(".cvj-bod").forEach(function (b, j) {
        b.setAttribute("aria-pressed", String(j === i));
      });
    }

    body.innerHTML = platna.map(function (m) {
      return '<button class="cvj-bod" type="button" aria-pressed="false" ' +
        'style="left:' + m.x + '%;top:' + m.y + '%" aria-label="' + m.jmeno + '">' +
        '<span class="cvj-jm">' + m.jmeno + '</span></button>';
    }).join("");
    body.querySelectorAll(".cvj-bod").forEach(function (b, i) {
      b.addEventListener("click", function () { ukaz(i); });
    });
    if (platna.length) ukaz(0);

    // ——— mřížka: co není na motorce (dílna) + cokoli, co v mapě chybí ———
    var naMotorce = {};
    platna.forEach(function (m) { (m.sku || []).forEach(function (s) { naMotorce[s] = 1; }); });
    var zbytek = produkty.filter(function (p) { return !naMotorce[p.sku]; });
    mrizka.innerHTML = zbytek.map(function (p) {
      var s = stav(p);
      return '<article class="cvj-karta">' +
        '<span class="cvj-kf">' + (p.foto ? '<img src="' + p.foto +
          '" alt="" loading="lazy">' : "") + '</span>' +
        '<b><a href="' + p.url + '">' + p.nazev + '</a></b>' +
        (vety[p.sku] ? '<span class="cvj-rada">' + vety[p.sku] + '</span>' : "") +
        '<span class="cvj-kd"><span class="cvj-cena">' + (p.rozsah ? "od " : "") +
          p.cena + '</span><span class="cvj-stav ' + s[0] + '">' + s[1] + '</span></span>' +
        '<button class="cvj-kosik" type="button" data-varianta="' + p.varianta + '"' +
          (p.koupitelne ? "" : " disabled") + '>' +
          (p.koupitelne ? "Do košíku" : "Nedostupné") + '</button></article>';
    }).join("");
  }).catch(function () { /* mapa nedostupná — stránka zůstane bez bodů */ });
})();
